import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import { showHelperText } from "../../../utils/utilityFunctions";
import { getRelationShip } from "../../home/portfolios/utils";

export default function ({ mobileFormik }: any) {
  return (
    <div
      className="email_realationship_container"
      style={{ maxWidth: 350, width: "50%" }}
    >
      <label
        style={{
          fontFamily: "OpenSans-SemiBold",
          fontSize: "15px",
          lineHeight: "18px",
          color: " #4f4f4f",
        }}
      >
        Mobile Family Relationship
      </label>
      <FormControl style={{ display: "block" }} variant="outlined">
        <Select
          className="email_text_input"
          name="mobileRelationship"
          value={mobileFormik.values.mobileRelationship}
          onChange={mobileFormik.handleChange}
          displayEmpty
        >
          <MenuItem disabled value="">
            <div style={{ color: "#C2C2C2" }}>Mobile Relationship</div>
          </MenuItem>
          {Object.keys(getRelationShip).map((key: any) => (
            <MenuItem value={key}>{getRelationShip[key]}</MenuItem>
          ))}
        </Select>
        <FormHelperText style={{ color: "red", padding: 0, fontSize: 12 }}>
          {showHelperText(mobileFormik, "mobileRelationship")}
        </FormHelperText>
      </FormControl>
    </div>
  );
}
